<template>
    <div class="game">
        <div class="info">
            <a class="btn btn-sm btn-outline-danger" :href="leaveUrl">Leave</a>
            <span class="status text-center text-muted">
                <span>{{ this.actionSuggestion }}</span>
            </span>
            <span class="code text-success">{{ this.code }}</span>
        </div>
        <Host v-if="host"></Host>
        <div class="row">
            <div class="col-12 col-sm-6">
                <Cards></Cards>
            </div>
            <div class="col-12 col-sm-6">
                <Members></Members>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';

  import Members from './Members';
  import Host from './Host';
  import Cards from './Cards';

  export default {
    props: ['initial-data'],
    components: {Members, Host, Cards},
    created() {
      const data = JSON.parse(this.initialData);
      this.$store.dispatch('game/initialize', data);
      this.$store.dispatch('channel/join', this.$store.state.game.code);
    },
    beforeDestroy() {
      this.$store.dispatch('channel/leave');
    },
    computed: {
      ...mapState({
        code: state => state.game.code,
        state: state => state.game.state,
        host: state => state.user.id === state.game.host_id
      }),
      leaveUrl() {
        return `/game/${this.code}/leave`;
      },
      actionSuggestion() {
        let activeVote = this.$store.getters['game/vote'];
        return this.state
          ? activeVote
            ? "Wait for round to end"
            : "Choose a card"
          : "Wait for next round to start";
      }
    },
  }
</script>

<style lang="scss" scoped>
    .game {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: calc(100vh - 400px);
    }

    .game > * {
        margin-bottom: 8px;
    }

    .info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .status {
            flex-grow: 1;
        }

        span.code {
            font-size: 1.4rem;
            font-weight: bold;
            font-family: monospace;
        }
    }
</style>
